import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
    selector: 'app-feed-page-anchor',
    templateUrl: './feed-page-anchor.component.html',
    styleUrls: ['./feed-page-anchor.component.scss'],
    standalone: false
})
export class FeedPageAnchorComponent implements OnInit {
   @Output() public intersected = new EventEmitter<any>();
   @Input('is-hidden') public isHidden = false;
  public constructor() { }

  public ngOnInit(): void {
  }

}
